module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_her2st.a49657a1.png";